/**
 * SeasonalBanner – kleines Saison-Abzeichen neben dem Namen im Dashboard + schwebende Deko-Emojis.
 */
import { Component, For, Show } from 'solid-js';
import { useSeason, SEASON_THEME } from '../utils/seasonal';
import { useTranslation } from '../context/LanguageContext';

export const SeasonalChip: Component = () => {
  const { season } = useSeason();
  const { t } = useTranslation();
  return (
    <Show when={season()}>
      {(s) => {
        const th = () => SEASON_THEME[s().name];
        return (
          <span class="season-chip" style={`--season-glow:${th().glow};`}>
            <span class="season-chip-emoji">{th().emojis[1]}</span>
            {t(th().chipKey)}
          </span>
        );
      }}
    </Show>
  );
};

/** Schwebende Emojis rechts im Dashboard-Kopf (nur Desktop) */
export const SeasonalScene: Component<{ hero?: boolean; head?: boolean }> = (props) => {
  const { season } = useSeason();
  return (
    <Show when={season()}>
      <div class={`season-scene season-scene--${season()!.name}`} classList={{ 'season-scene--hero': props.hero, 'season-scene--head': props.head }} aria-hidden="true">
        <For each={props.hero || props.head ? [...SEASON_THEME[season()!.name].emojis, ...SEASON_THEME[season()!.name].emojis] : SEASON_THEME[season()!.name].emojis}>
          {(e, i) => <span class="season-scene-item" style={`--i:${i()};`}><span class="season-scene-inner">{e}</span></span>}
        </For>
      </div>
    </Show>
  );
};

const CORNER: Record<string, string> = { snow: '🎄', sparks: '🎃', fireworks: '🍾', leaves: '🍄', blossom: '🌷' };

/** Dekoration an Dashboard-Kacheln: variant "hud" = Rand-Deko oben, "wheel" = kleines Eck-Emoji am Glücksrad */
export const SeasonalOrnament: Component<{ variant: 'hud' | 'wheel' }> = (props) => {
  const { season } = useSeason();
  return (
    <Show when={season()}>
      <Show when={props.variant === 'hud'}
        fallback={<span class={`season-corner season-corner--${season()!.name}`} aria-hidden="true">{CORNER[season()!.name]}</span>}>
        <div class={`season-cap season-cap--${season()!.name}`} aria-hidden="true">
          <Show when={season()!.name !== 'snow'}>
            <span class="season-cap-a">{SEASON_THEME[season()!.name].emojis[season()!.name === 'sparks' ? 3 : 0]}</span>
            <span class="season-cap-b">{SEASON_THEME[season()!.name].emojis[1]}</span>
          </Show>
        </div>
      </Show>
    </Show>
  );
};

/** Kleine Girlande unter dem Sidebar-Logo */
export const SeasonalGarland: Component = () => {
  const { season } = useSeason();
  return (
    <Show when={season()}>
      <div class={`season-garland season-garland--${season()!.name}`} aria-hidden="true">
        <For each={[...SEASON_THEME[season()!.name].emojis, ...SEASON_THEME[season()!.name].emojis.slice(0, 1)]}>
          {(e, i) => <span style={`--i:${i()};`}>{e}</span>}
        </For>
      </div>
    </Show>
  );
};
